export default __webpack_public_path__ + "static/media/menu-more.176317aa.svg";